/**
 * This constant file contains breakpoints that are used across multiple components.
 */
export class BreakpointConstant {
  public static readonly MOBILE_LARGE: number = 600;
  public static readonly TABLET: number = 1024;
}
